// extracted by mini-css-extract-plugin
export default {"techList":"ProjectDescription_techList__3uDTa","projectLinks":"ProjectDescription_projectLinks__ODM6y"};